import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SimpleSlider = ({ slides = [], onClick }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  };

  return (
    <>
      {slides.length > 1 ? (
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index}>
              <img
                src={slide}
                alt={`slide-${index}`}
                style={{ width: "100%", height: "600px", objectFit: "contain", cursor: "pointer" }}
                onClick={() => onClick && onClick(index)}
              />
            </div>
          ))}
        </Slider>
      ) : slides.length === 1 ? (
        <img
          src={slides[0]}
          alt="single-slide"
          style={{
            width: slides[0] === "/assets/urszula_logo.png" ? "200px" : "100%", // inny rozmiar dla logo
            height: slides[0] === "/assets/urszula_logo.png" ? "200px" : "auto",
            objectFit: slides[0] === "/assets/urszula_logo.png" ? "contain" : "contain",
            cursor: "pointer"
          }}
          onClick={() => onClick && onClick(0)}
        />
      ) : null}
    </>
  );

};

export default SimpleSlider;